import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { IntelligenceGroupBy, UnitIntelligenceService } from 'src/app/services/unit-intelligence.service';

const COLUMN_LABEL: Record<IntelligenceGroupBy, string> = { unit: 'Unidad', driver: 'Operador', client: 'Cliente' };
const TITLE_ENTITY: Record<IntelligenceGroupBy, string> = { unit: 'unidad', driver: 'operador', client: 'cliente' };

/** Mini-panel de ranking del dashboard ("Ranking por unidad/operador/
 * cliente"). Tiene su PROPIO selector de fechas (independiente del filtro
 * general del dashboard arriba) y hace su propia consulta al backend, en
 * vez de depender del payload del dashboard — así cada panel puede mirar
 * un periodo distinto sin afectar a los demás ni a las tarjetas KPI. */
@Component({
    selector: 'app-ranking-mini-panel',
    templateUrl: './ranking-mini-panel.component.html',
    styleUrls: ['./ranking-mini-panel.component.css']
})
export class RankingMiniPanelComponent implements OnInit {
    @Input() groupBy: IntelligenceGroupBy = 'unit';

    year = new Date().getFullYear();
    month = new Date().getMonth();
    rows: any[] = [];
    loading = false;

    constructor(private svc: UnitIntelligenceService, private router: Router) { }

    get columnLabel(): string {
        return COLUMN_LABEL[this.groupBy];
    }

    get title(): string {
        return `Ranking por ${TITLE_ENTITY[this.groupBy]}`;
    }

    ngOnInit(): void {
        this.fetch();
    }

    /** Primer y último día del mes/año seleccionado, para la consulta —
     * el mini-panel muestra "Este mes" (o el mes elegido) como un periodo
     * completo, no un rango de días arbitrario. */
    private monthRange(): { from: string; to: string } {
        const from = new Date(this.year, this.month, 1);
        const to = new Date(this.year, this.month + 1, 0);
        const toIso = (d: Date) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
        return { from: toIso(from), to: toIso(to) };
    }

    fetch(): void {
        this.loading = true;
        const { from, to } = this.monthRange();
        this.svc.getRanking(this.groupBy, { from, to, page: 1, per_page: 5 }).subscribe({
            next: (resp: any) => {
                this.rows = resp?.table?.data || [];
                this.loading = false;
            },
            error: () => {
                this.loading = false;
            }
        });
    }

    onPeriodApplied(): void {
        this.fetch();
    }

    goToHistory(id: number): void {
        this.router.navigate(['/unit/intelligence-center/history', this.groupBy, id]);
    }

    goToRanking(): void {
        this.router.navigate(['/unit/intelligence-center/ranking', this.groupBy]);
    }

    formatCurrency(value: number | null | undefined): string {
        if (value === null || value === undefined) return '—';
        return new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(value);
    }

    formatKm(value: number | null | undefined): string {
        if (value === null || value === undefined) return '—';
        return `${new Intl.NumberFormat('es-MX').format(value)} km`;
    }

    costPerKmClass(efficiency: string | null | undefined): string {
        if (efficiency === 'Óptima' || efficiency === 'Buena') return 'cell-cost--low';
        if (efficiency === 'Media' || efficiency === 'Alta') return 'cell-cost--mid';
        if (efficiency === 'Crítica') return 'cell-cost--high';
        return '';
    }
}
